import { Search, GraduationCap, Compass, Layers, User, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@legendapp/state/react';
import { useChat } from '../context/ChatContext';
import { xp$ } from '../store';
import './Navigation.css';

export default function Navigation({ activeTab, onTabChange }) {
  const { t } = useTranslation('navigation');
  const { startNewChat } = useChat();
  const todayXP = useSelector(() => xp$.todayXP.get());

  const tabs = [
    { id: 'query', icon: Search, label: t('query') },
    { id: 'course', icon: GraduationCap, label: t('course') },
    { id: 'discovery', icon: Compass, label: t('discovery') },
    { id: 'review', icon: Layers, label: t('review') },
    { id: 'profile', icon: User, label: t('profile') },
  ];

  const handleLogoClick = () => {
    // Switch to query tab if not already there
    if (activeTab !== 'query') {
      onTabChange('query');
    }
    // Start new chat
    startNewChat();
  };

  return (
    <nav className="nav-container">
      {/* Desktop logo - only visible on desktop */}
      <button className="nav-logo" onClick={handleLogoClick}>
        {/* <img src="/logo.svg" alt="Mellow" className="logo-icon" /> */}
        <span className="logo-text" style={{marginLeft: 20}}>Mellowly</span>
      </button>

      <div className="nav-content">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <div className="icon-wrapper">
                <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                {isActive && (
                  <motion.div
                    layoutId="activeTabIndicator"
                    className="active-indicator"
                    initial={false}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
              </div>
              <span className="nav-label">{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Desktop XP Counter - at bottom of sidebar, only visible on desktop */}
      <div className="nav-xp-counter">
        <Sparkles size={18} className="xp-icon" />
        <span className="xp-number">{todayXP} XP</span>
        <span className="xp-label">{t('today')}</span>
      </div>
    </nav>
  );
}
